<template>
  <div class="login" :class="{loading: loading}" style="overflow-y:scroll;width:100%;height:100%">
      <router-view :setloading="setLoading"></router-view>
  </div>
</template>

<script>

export default {
  name: 'login',
  data: function () {
    return {
      loading: false
    }
  },
  methods: {
    setLoading (status) {
      this.loading = status
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Login.vue